jQuery(document).ready(function ($) {

});    // Intersection Observer for scroll animations
const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
};

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target); // Only animate once
        }
    });
}, observerOptions);

// Observe elements to animate on scroll
document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.querySelector('.ep-container'));
    observer.observe(document.querySelector('.about-container'));
    observer.observe(document.querySelector('.gallery-container'));

    // Parallax effect to backgrounds
    window.addEventListener('scroll', () => {
        const scrollPosition = window.pageYOffset;

        // Parallax on the EP section background
        document.querySelector('.ep-section').style.backgroundPositionY = scrollPosition * 0.05 + 'px';

        // Rotation on scroll for the frames
        const frames = document.querySelectorAll('.gallery-frame');
        frames.forEach((frame, index) => {
            const direction = index % 2 === 0 ? 1 : -1;
            const rotateValue = Math.min(scrollPosition * 0.01, 10) * direction;
            frame.style.transform = `rotateY(${rotateValue}deg)`;
        });
    });

    // Hover animation for nav links
    const navLinks = document.querySelectorAll('.nav-links a');
    navLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
            link.style.transition = 'all 0.3s ease';
            link.style.transform = 'translateY(-3px)';
        });

        link.addEventListener('mouseleave', () => {
            link.style.transform = 'translateY(0)';
        });
    });

    // Float animation for logo
    const logo = document.querySelector('.logo');
    setInterval(() => {
        logo.style.animation = 'none';
        setTimeout(() => {
            logo.style.animation = 'glow 3s infinite';
        }, 10);
    }, 6000);

    // Pulse animation to listen button
    const listenBtn = document.querySelector('.listen-btn');
    listenBtn.addEventListener('mouseenter', () => {
        listenBtn.style.animation = 'pulse 1s infinite';
    });

    listenBtn.addEventListener('mouseleave', () => {
        listenBtn.style.animation = 'none';
    });
});